import React, { Component, PropTypes } from 'react';
import { Header } from 'components/header/Header';
import { ScrollingResults } from 'components/scrollingResults/ScrollingResults';
import { Loader } from 'components/loader/Loader';
import { Error } from 'components/error/Error';
import { utils } from 'bastetjs';
import { getScrollingResults } from 'streams/getScrollingResults';


export class MainComponent extends Component {
  // This might be a reason to have an includeOnlyChangedProps in the connector?
  static excludeChangedProps = ['children', 'history', 'location', 'route', 'routeParams', 'routes'];

  static propTypes = {
    scrollingData: PropTypes.object
  }

  static defaultProps = {
    scrollingData: {
      isError: false,
      error: false,
      isLoading: true,
      info: {},
      panel: {},
      results: {},
      races: {},
      messages: {}
    }
  }
  render() {

    const {
      isError,
      error,
      isLoading,
      info,
      panel,
      results,
      races,
      messages
    } = this.props.scrollingData;

    if (isLoading) {
      return <Loader message="loading"/>;
    }

    if (isError) {
      return <Error errorMsg="data-load-error" />;
    }

    const scrollProps = {
      results,
      races,
      settings: panel.settings,
    };
    let hideHeader = parseInt(panel.settings.hide_header) || 0;
    let fontClass = panel.settings.font ? 'font-' + panel.settings.font : 0;
    let color = panel.settings.text_color ? panel.settings.text_color : '#fff';
    return (
      <div className={fontClass} style={{color}}>
          { !hideHeader ? <Header info={info} panelInfo={panel.settings} /> : null}
          <ScrollingResults {...scrollProps} />
      </div>
    );
  }
}

export const Main = utils.connectStream({scrollingData:getScrollingResults})(MainComponent);



// WEBPACK FOOTER //
// ./views/main/Main.js